(() => {
  const roots = document.querySelectorAll('[data-product-root]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const variantsScript = root.querySelector('[data-product-json]');
    let variants = [];
    try { variants = variantsScript ? JSON.parse(variantsScript.textContent) : []; } catch (_) { variants = []; }

    const form = root.querySelector('[data-product-form]');
    const variantInput = root.querySelector('[data-variant-id]');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const addButton = root.querySelector('.product-add-to-cart');
    const buyButton = root.querySelector('.product-buy-now');
    const addText = root.querySelector('[data-add-to-cart-text]');
    const mobileAdd = root.querySelector('[data-mobile-add-to-cart]');
    const mobileBuy = root.querySelector('[data-mobile-buy-now]');

    const getQuantity = () => Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    const selectedOptions = () => [...root.querySelectorAll('[data-option-value]:checked')].map((input) => input.value);
    const selectedVariant = () => variants.find((variant) => variant.options.every((value, index) => value === selectedOptions()[index])) || variants[0];

    const addToCart = async (redirectToCheckout = false, triggerButton = addButton) => {
      const id = Number(variantInput?.value);
      if (!id || triggerButton?.disabled) return;
      const originalLabel = triggerButton?.textContent?.trim() || '';
      triggerButton.disabled = true;
      triggerButton.classList.add('is-loading');
      if (triggerButton === addButton && addText) addText.textContent = 'Adding…';
      else triggerButton.textContent = 'Please wait…';
      try {
        const routeRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${routeRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id, quantity: getQuantity() })
        });
        if (!response.ok) throw new Error('Unable to add item');
        if (redirectToCheckout) {
          window.location.href = `${routeRoot}checkout`;
          return;
        }
        window.AnayaToast?.('✅ Added to cart', 'success');
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (error) {
        window.AnayaToast?.('❌ Could not add to cart', 'error');
      } finally {
        triggerButton.classList.remove('is-loading');
        triggerButton.disabled = false;
        if (triggerButton === addButton && addText) addText.textContent = originalLabel;
        else triggerButton.textContent = originalLabel;
      }
    };

    const updateVariant = () => {
      const variant = selectedVariant();
      if (!variant || !variantInput) return;
      variantInput.value = variant.id;
      const available = Boolean(variant.available);
      [addButton, buyButton, mobileAdd, mobileBuy].forEach((button) => { if (button) button.disabled = !available; });
      if (addText) addText.textContent = available ? 'Add to Cart' : 'Sold Out';
      if (mobileAdd) mobileAdd.textContent = available ? 'Add to Cart' : 'Sold Out';
      const stock = root.querySelector('[data-product-stock]');
      if (stock) {
        stock.classList.toggle('is-out', !available);
        stock.innerHTML = available ? '<span aria-hidden="true">●</span> In stock' : '<span aria-hidden="true">●</span> Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    root.querySelectorAll('[data-option-value]').forEach((input) => input.addEventListener('change', updateVariant));
    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { if (quantityInput) quantityInput.value = String(Math.max(1, getQuantity() - 1)); });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { if (quantityInput) quantityInput.value = String(getQuantity() + 1); });
    quantityInput?.addEventListener('change', () => { quantityInput.value = String(getQuantity()); });

    form?.addEventListener('submit', (event) => { event.preventDefault(); addToCart(false, addButton); });
    buyButton?.addEventListener('click', () => addToCart(true, buyButton));
    mobileAdd?.addEventListener('click', () => addToCart(false, mobileAdd));
    mobileBuy?.addEventListener('click', () => addToCart(true, mobileBuy));

    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const images = [...root.querySelectorAll('[data-gallery-image]')];
    const currentCounter = root.querySelector('[data-image-current]');
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => {
      thumbs.forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-pressed', 'false'); });
      images.forEach((item) => item.classList.add('is-hidden'));
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
      images[index]?.classList.remove('is-hidden');
      if (currentCounter) currentCounter.textContent = String(index + 1);
    }));

    const lightbox = root.querySelector('[data-product-lightbox]');
    const lightboxImage = root.querySelector('[data-lightbox-image]');
    images.forEach((button) => button.addEventListener('click', () => {
      const image = button.querySelector('img');
      if (!image || !lightbox || !lightboxImage || typeof lightbox.showModal !== 'function') return;
      lightboxImage.src = image.currentSrc || image.src;
      lightboxImage.alt = image.alt;
      lightbox.showModal();
    }));
    root.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
    lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });

    const description = root.querySelector('[data-description-source]');
    const specificationsContent = root.querySelector('[data-specifications-content]');
    const specificationsFallback = root.querySelector('[data-specifications-fallback]');
    if (description && specificationsContent) {
      const headings = [...description.querySelectorAll('h1,h2,h3,h4,h5,h6,strong,b,p')];
      const specHeading = headings.find((node) => /^(specifications?|product specifications?|details and specifications?|details & specifications?)\s*:?$/i.test(node.textContent.trim()));
      if (specHeading) {
        let node = specHeading.nextSibling;
        const moved = [];
        while (node) {
          const next = node.nextSibling;
          const isHeading = node.nodeType === 1 && /^H[1-6]$/.test(node.tagName);
          if (isHeading) break;
          moved.push(node);
          node = next;
        }
        specHeading.remove();
        moved.forEach((item) => specificationsContent.appendChild(item));
        if (specificationsContent.textContent.trim()) specificationsFallback?.setAttribute('hidden', '');
      }
    }

    const tabButtons = [...root.querySelectorAll('[data-tab]')];
    const panels = [...root.querySelectorAll('[data-tab-panel]')];
    const accordionItems = [...root.querySelectorAll('[data-accordion-item]')];
    const activateTab = (name) => {
      tabButtons.forEach((button) => button.setAttribute('aria-selected', String(button.dataset.tab === name)));
      panels.forEach((panel) => { panel.hidden = panel.dataset.tabPanel !== name; });
      accordionItems.forEach((item) => {
        const open = item.dataset.accordionItem === name;
        item.classList.toggle('is-open', open);
        item.querySelector('[data-accordion-trigger]')?.setAttribute('aria-expanded', String(open));
      });
    };
    tabButtons.forEach((button) => button.addEventListener('click', () => activateTab(button.dataset.tab)));
    root.querySelectorAll('[data-accordion-trigger]').forEach((button) => button.addEventListener('click', () => {
      const name = button.dataset.accordionTrigger;
      const item = button.closest('[data-accordion-item]');
      const isOpen = item?.classList.contains('is-open');
      if (isOpen && window.matchMedia('(max-width: 989px)').matches) {
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        item.querySelector('[data-tab-panel]').hidden = true;
      } else activateTab(name);
    }));
    activateTab('description');

    root.querySelector('[data-scroll-to-reviews]')?.addEventListener('click', (event) => {
      event.preventDefault();
      activateTab('reviews');
      loadReviews();
      root.querySelector('#product-reviews')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });


    const reviewsSection = root.querySelector('[data-product-reviews]');
    const reviewsRoot = root.querySelector('#judgeme_product_reviews');
    const reviewsMore = root.querySelector('[data-reviews-more]');
    const writeReviewButton = root.querySelector('[data-write-review]');
    let reviewsExpanded = false;

    const initializeJudgeMe = () => {
      try {
        if (window.jdgm?.init_widgets) window.jdgm.init_widgets();
        else if (window.jdgm?.initialize) window.jdgm.initialize();
        else document.dispatchEvent(new CustomEvent('judgeme:refresh'));
      } catch (_) {}
    };

    const updateReviewLimit = () => {
      if (!reviewsRoot) return;
      const reviews = [...reviewsRoot.querySelectorAll('.jdgm-rev')];
      reviews.forEach((review, index) => review.classList.toggle('is-theme-review-hidden', !reviewsExpanded && index >= 3));
      if (reviewsMore) {
        const nativeMore = reviewsRoot.querySelector('.jdgm-paginate__next-page, .jdgm-paginate__load-more, [data-jdgm-load-more]');
        reviewsMore.hidden = reviews.length <= 3 && !nativeMore;
        reviewsMore.textContent = reviewsExpanded ? 'Show Fewer Reviews' : 'See More Reviews';
      }
    };

    const loadReviews = () => {
      initializeJudgeMe();
      window.setTimeout(updateReviewLimit, 180);
    };

    if (reviewsRoot) {
      new MutationObserver(updateReviewLimit).observe(reviewsRoot, { childList: true, subtree: true });
      loadReviews();
    }

    const revealJudgeForm = () => {
      const form = reviewsRoot?.querySelector('.jdgm-form-wrapper, .jdgm-form');
      if (!form) return false;
      form.hidden = false;
      form.style.display = 'block';
      form.classList.add('is-open');
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      form.querySelector('input, textarea, select')?.focus({ preventScroll: true });
      return true;
    };

    const openReviewForm = () => {
      activateTab('reviews');
      initializeJudgeMe();
      const tryOpen = (attempt = 0) => {
        const nativeButton = reviewsRoot?.querySelector('.jdgm-write-rev-link, [data-jdgm-write-review], .jdgm-write-rev-link.jdgm-write-rev-link');
        if (nativeButton) {
          nativeButton.click();
          window.setTimeout(() => { if (!revealJudgeForm() && attempt < 12) tryOpen(attempt + 1); }, 100);
        } else if (!revealJudgeForm() && attempt < 12) {
          window.setTimeout(() => tryOpen(attempt + 1), 180);
        } else if (attempt >= 12) {
          reviewsSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          window.AnayaToast?.('Review form requires the Judge.me widget to be enabled for this product.', 'error');
        }
      };
      tryOpen();
    };
    writeReviewButton?.addEventListener('click', openReviewForm);

    reviewsMore?.addEventListener('click', () => {
      if (!reviewsExpanded) {
        reviewsExpanded = true;
        reviewsRoot?.querySelector('.jdgm-paginate__next-page, .jdgm-paginate__load-more, [data-jdgm-load-more]')?.click();
      } else {
        reviewsExpanded = false;
        reviewsSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      window.setTimeout(updateReviewLimit, 160);
    });

    tabButtons.filter((button) => button.dataset.tab === 'reviews').forEach((button) => button.addEventListener('click', loadReviews));
    root.querySelector('[data-accordion-trigger="reviews"]')?.addEventListener('click', loadReviews);

    const readMore = root.querySelector('[data-read-more]');
    readMore?.addEventListener('click', () => {
      const collapsed = description?.classList.toggle('is-collapsed');
      readMore.textContent = collapsed ? 'Read More' : 'Show Less';
      readMore.setAttribute('aria-expanded', String(!collapsed));
    });

    root.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-carousel-track]');
      const move = (direction) => track?.scrollBy({ left: direction * Math.max(260, track.clientWidth * .85), behavior: 'smooth' });
      carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => move(1));
    });
  });
})();
